import { ref } from 'vue'

export default function (type: 'pc' | 'mobile') {
  const elList = ref<any[]>([])

  const addSwiper = (record: any) => {
    elList.value.push(record)
  }

  const startSwiper = () => {
    elList.value.forEach(el => {
      // @ts-ignore
      new Swiper(el.id, {
        width: type === 'mobile' ? null : 890,
        height: type === 'mobile' ? null : 667,
        navigation: type === 'mobile' ? {} : {
          nextEl: '.swiper-next',
          prevEl: '.swiper-prev',
          disabledClass: 'swiper-disabled'
        },
        pagination: {
          el: '.swiper-pagination'
        },
        autoplay: {
          delay: el.time * 1000,
          disableOnInteraction: false
        },
        loop: el.isLoop,
        on: {
          slideChange: function (val) {
            if (val.realIndex === el.length - 1) {
              if (el.isLoop) {
                return
              } else {
                this.autoplay.stop()
              }
            } else {
              if (!el.isLoop) {
                this.autoplay.start()
              }
            }
          }
        }

      })
    })
  }

  return {
    addSwiper,
    startSwiper
  }
}
